/**
 * Storage optimizer utilities for Redux persist performance
 */

// Check localStorage size
export const getStorageSize = (): number => {
  let totalSize = 0;
  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      const value = localStorage.getItem(key) || '';
      // Rough estimate: 2 bytes per character (UTF-16)
      totalSize += (key.length + value.length) * 2;
    }
  }
  return totalSize;
};

// Analyze storage usage by key
export const analyzeStorageUsage = (): { key: string; size: number }[] => {
  const sizes: { key: string; size: number }[] = [];
  
  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      const value = localStorage.getItem(key) || '';
      const size = (key.length + value.length) * 2;
      sizes.push({ key, size });
    }
  }
  
  // Sort by size descending
  sizes.sort((a, b) => b.size - a.size);
  return sizes;
};

// Clean up old persist data
export const cleanupOldPersistData = (): void => {
  const keysToRemove: string[] = [];
  
  for (const key in localStorage) {
    if (key.startsWith('persist:') && !key.includes(process.env.REACT_APP_ENV_MODE || 'local')) {
      keysToRemove.push(key);
    }
  }
  
  if (keysToRemove.length > 0) {
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
};

// Initialize storage optimization
export const initStorageOptimization = (): void => {
  // Clean up old data on startup
  cleanupOldPersistData();
};